const Sheet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M21 10v5c0 5-1.8 7-6.3 7H9.3C4.8 22 3 20 3 15V9c0-5 1.8-7 6.3-7h4.5"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M21 10h-3.5C14.875 10 14 9 14 6V2l7 8Z"
    />
  </svg>
);
export default Sheet;
